import React, {useState, useEffect} from 'react'
import axios from 'axios'
import PreferenceForm from './PreferenceForm' // Tercih formunu temsil eden bileşen
import {PreferencePeriod} from './_models'
import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert2'

const API_URL_REAL = process.env.REACT_APP_API_URL

const PreferencePage = (): React.ReactElement | null => {
  const [preferencePeriod, setPreferencePeriod] = useState<PreferencePeriod | null>(null)
  const [futurePeriods, setFuturePeriods] = useState<PreferencePeriod[]>([])
  const [loading, setLoading] = useState(true)
  const [isPlaced, setIsPlaced] = useState<boolean | null>(null)

  const navigate = useNavigate()
  const intl = useIntl()

  useEffect(() => {
    const fetchData = async () => {
      try {
        // İlk olarak tüm verileri yükle
        const [preferenceResponse, placementResponse] = await Promise.all([
          axios.get<PreferencePeriod[]>(`${API_URL_REAL}/Custom/GetPreferencePeriods`),
          axios.get<boolean>(`${API_URL_REAL}/Custom/UserPlacementInfo`),
        ])

        const periods = preferenceResponse.data
        const now = new Date()
        const activePeriod = periods.find(
          (period) => new Date(period.startDate) <= now && new Date(period.endDate) >= now
        )
        const future = periods.filter((period) => new Date(period.startDate) > now)

        setPreferencePeriod(activePeriod || null)
        setFuturePeriods(future)
        setIsPlaced(placementResponse.data)
      } catch (error) {
        swal
          .fire({
            title: intl.formatMessage({id: 'Error'}),
            text: intl.formatMessage({id: 'Unknown error'}),
            icon: 'error',
            confirmButtonText: intl.formatMessage({id: 'Okay'}),
          })
          .then((result) => {
            if (result.isConfirmed) {
              navigate('/dashboard')
            }
          })
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [intl, navigate])

  if (loading) {
    return <p>Loading...</p>
  }

  if (!preferencePeriod) {
    return (
      <div>
        <div className='alert alert-danger'>
          {intl.formatMessage({
            id: 'Currently, there is no active preference period. Please check the guideline.',
          })}
        </div>
        {futurePeriods.length > 0 && (
          <div>
            <h2>
              {intl.formatMessage({
                id: 'Upcoming Preference Periods',
              })}
              :
            </h2>
            <ul>
              {futurePeriods.map((period, index) => (
                <li key={index}>
                  {period.name} ({new Date(period.startDate).toLocaleDateString()} -{' '}
                  {new Date(period.endDate).toLocaleDateString()})
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    )
  }

  if (isPlaced) {
    return (
      <div>
        <div className='alert alert-info'>
          {intl.formatMessage({id: 'You have already been placed.'})}
        </div>
      </div>
    )
  }

  return (
    <div>
      <h2>{preferencePeriod.name}</h2>
      {/* Tercih formunu burada gösteriyoruz. Form için ilgili props'ları ekleyin. */}
      <PreferenceForm period={preferencePeriod} />
    </div>
  )
}

export default PreferencePage
